jQuery(document).ready(function () {
    // Controls start and stop of globe animation
    // There should be a global bodymovin object that is an instance of this https://github.com/airbnb/lottie-web
    // Initialize it, and use it to control start and stop

    // Use window focus and blur events, as well as intersectionobserver to determine when the
    // element is in view. If intersection observer is not supported, just do nothing.
    var appendGlobe = document.getElementById('animatedGlobe')
    
    if (appendGlobe != null){ // only the home page (for now) has this animation
        var isIntersecting = false;
        var blockAnimation = false;

        function initialize() {
            var animData = {
                container: appendGlobe,
                renderer: 'svg',
                loop: true,
                autoplay: false,
                rendererSettings: {
                    context: appendGlobe,
                    progressiveLoad: true,
                },
                path: mmThemeURI + '/assets/js/lib/globe-data.json'
            };
            bodymovin.loadAnimation(animData);
            bodymovin.setQuality('low');
            setTimeout(setIntersectionObserver, 4000);
        }

        // WINDOW EVENT HANDLERS
        jQuery(window).on('focus', function () {
            updateAnimation();
        });
        jQuery(window).on('blur', function () {
            updateAnimation();
        });

        jQuery(window).on('video-box-start', function () {
            blockAnimation = true;
            updateAnimation();
        });
        jQuery(window).on('video-box-end', function () {
            blockAnimation = false;
            updateAnimation();
        });

        function updateAnimation() {
            if (
                !document.hasFocus() ||
                blockAnimation ||
                !isIntersecting
            ) {
                stop();
            } else {
                start();
            }
        }

        function start() {
            bodymovin.play();
        }

        function stop() {
            bodymovin.pause();
        }


        // Set up intersection observer and update animation when/not intersecting
        function setIntersectionObserver() {
            var intersectionObserver = new IntersectionObserver(function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    if (entry.isIntersecting) {
                        isIntersecting = true;
                        updateAnimation();
                    } else {
                        isIntersecting = false;
                        updateAnimation();
                    }
                }
            });
            intersectionObserver.observe(appendGlobe);
        }

        initialize();
    }
});

